import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({ whatsapp_number: "", company_name: "MultiServizi", tagline: "" });
  const [categories, setCategories] = useState([]);
  const [pages, setPages] = useState([]);

  const refresh = () => {
    api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {});
    api.get("/categories").then(({ data }) => setCategories(data)).catch(() => {});
    api.get("/pages").then(({ data }) => setPages(data)).catch(() => {});
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SiteContext.Provider value={{ settings, categories, pages, refresh }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
